<template>
  <el-scrollbar class="kq-theme-menu scroll-hide-x">
    <div
      v-for="menu of menus"
      :key="menu.path"
      @click="selectMenu(menu.path)"
      :class="{ 'kq-theme-menu-item': true, 'kq-theme-menu-item-active': currentMenuPath === menu.path }"
    >
      <kq-icon :name="menu.icon || 'folder-o'" />
      <span class="kq-theme-menu-item-title">{{ menu.title || '未命名菜单' }}</span>
    </div>
  </el-scrollbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SideMenu',
  props: {
    menus: {
      type: Array,
      required: true
    },
    currentMenuPath: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('tab', ['tabs'])
  },
  methods: {
    selectMenu(path) {
      if (this.$util.validate.isExternal(path)) {
        this.$util.open(path)
      } else {
        const info = this.tabs.find(tab => tab.path === path)
        if (info) {
          this.$router.push({
            name: info.name,
            params: info.params || {},
            query: info.query || {}
          })
        } else {
          this.$router.push({ path: path })
        }
      }
    }
  }
}
</script>
